/**
 * @returns the full display text for a given interest level abbreviation
 */
export function getFullInterestLevel(interestLevel) {
	let ret;
	const interestLevels = {
		'LG': 'Lower Grades (K-3)',
		'MG': 'Middle Grades (4-8)',
		'MG+': 'Upper Middle Grades (6+)',
		'UG': 'Upper Grades (9-12)'
	}
	if(interestLevels[interestLevel]) {
		ret = interestLevels[interestLevel]
	}

	return ret;
}



// WEBPACK FOOTER //
// ./src/data/AcceleratedReaderUtility.js